// Imports
import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'
import VuexPersist from 'vuex-persist';
import localForage from 'localforage';

import * as modules from './modules'

Vue.use(Vuex)

const rawUsername = (username) => {
  if (username == null || username === '') return null;
  return String(username).replace(/[^\w]/gi, '');
};

const isEmbedded = (() => {
  try {
    if (window.self !== window.top) return true;
    return /(?:^|[?&])embed=ghost(?:&|$)/.test(window.location.search || '');
  } catch (e) {
    return true;
  }
})();

const vuexLocalStorage = new VuexPersist({
  key: isEmbedded ? 'vuex-embed' : 'vuex',
  storage: isEmbedded ? window.sessionStorage : localForage,
  asyncStorage: !isEmbedded,
  reducer: (state) => {
    try {
      // Always reload countries from local/remote — don't persist the list
      const { countries, ...appRest } = state.app || {};
      const app = { ...appRest, countries: [] };

      if (!state?.user) return { ...state, app };

      const user = { ...state.user };

      if (user.cpf != null && (user.profile == null || user.profile.cpf == null)) {
        user.profile = { ...(user.profile || {}), cpf: user.cpf };
      }
      delete user.cpf;

      if (user.username != null) {
        user.username = rawUsername(user.username);
      }

      return { ...state, app, user };
    } catch (error) {
      console.warn('vuex-persist reducer failed', error);
      return state;
    }
  },
})

const store = new Vuex.Store({
  plugins: [pathify.plugin, vuexLocalStorage.plugin],
  modules,
})

// Fail-safe restore: never hang navigation if IndexedDB/localforage errors
const STORE_RESTORE_TIMEOUT_MS = 5000;
const restored = Promise.resolve(store.restored)
  .catch((error) => {
    console.warn('vuex localforage restore failed', error);
  });

store.restored = Promise.race([
  restored,
  new Promise((resolve) => setTimeout(resolve, STORE_RESTORE_TIMEOUT_MS)),
]);

export default store
